import {
    addNewPi,
    getProcessingInstruction,
} from '../../../utility/xmlHelpers';
import {
    getDocumentElement,
    setNodeValue,
    xmlToString,
} from '../../../xmlUtility';

const $ = window.jQuery;

export const DBXL_PI_NAME = 'QdabraDBXL';

function getOrAddDbxlPIFromDsNode(dsNode) {
    const pi = getProcessingInstruction(dsNode, DBXL_PI_NAME);

    if (pi) {
        return pi;
    }

    return addNewPi(dsNode, DBXL_PI_NAME);
}

export function setDbxlPiValues(
    navigator,
    docId,
    docType,
    name,
    author,
    description,
) {
    var pi = getOrAddDbxlPIFromDsNode(navigator);
    var piDoc = $.parseXML(
        '<root docid="" doctype="" name="" author="" description="" />',
    );

    var rootNode = getDocumentElement(piDoc);

    rootNode.setAttribute('docid', docId);

    if (!docType) {
        rootNode.attributes.removeNamedItem('doctype');
    } else {
        rootNode.setAttribute('doctype', docType);
    }

    rootNode.setAttribute('name', name);
    rootNode.setAttribute('author', author);
    rootNode.setAttribute('description', description);

    let xml = xmlToString(piDoc);

    // now remove '<root ' and '/>'
    if (xml.indexOf('<root ') === 0 && xml.indexOf('/>') === xml.length - 2) {
        xml = xml.substr(6);
        xml = xml.substr(0, xml.length - 2);

        pi.nodeValue = xml;
        return;
        //return pi.setValueAsync(xml);
    }

    setNodeValue(pi, `docid="${docId}"`);
}
